module.exports = __webpack_public_path__ + "static/media/wired_comm.ae8719f6.jpg";